import { ecart as _ecart, ecartLabel as _ecartLabel, ecartClass as _ecartClass } from '@/utils/inventaire-helpers'

export default {
  name: 'inventaire-produits-table',
  props: {
    produits: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    quantites: { type: Object, default: () => ({}) },
    selection: { type: Array, default: () => [] },
    perimetreType: { type: String, default: 'stock_complet' },
    renseignementDemande: { type: Boolean, default: false },
    demandeEnCours: { type: Boolean, default: false },
  },
  computed: {
    produitsDisponibles() {
      return this.produits.filter(item => !this.produitIndisponible(item))
    },
    produitsIndisponibles() {
      return this.produits.filter(item => this.produitIndisponible(item))
    },
    fieldsIndisponibles() {
      const base = this.fields.filter(field => ['article', 'quantite'].includes(field.key))
      return [...base, { key: 'statut', label: 'État' }]
    },
  },
  methods: {
    produitIndisponible(item) {
      return !!(item && item.indisponible_inventaire && !this.demandeEnCours)
    },
    toggleSelection(id) {
      const selection = this.selection.includes(id)
        ? this.selection.filter(item => item !== id)
        : [...this.selection, id]
      this.$emit('update:selection', selection)
    },
    updateQuantite(id, value) {
      this.$emit('update:quantites', { ...this.quantites, [id]: value })
    },
    ecart(item) {
      return _ecart(this.quantites[item.article_repartition_id], item.quantite)
    },
    ecartLabel(item) {
      return _ecartLabel(this.ecart(item))
    },
    ecartClass(item) {
      return _ecartClass(this.ecart(item))
    },
  },
}
